var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { fetchApi, translate } from '@js/common/helpers';
import { useCallback, useEffect, useRef, useState } from "react";
import { MoodboardRow } from "./MoodboardRow";
import { MoodboardForm } from "./MoodboardForm";
import InfiniteScroll from "tagwalk-api-client/assets/js/Components/InfiniteScroll";
import debounce from "lodash.debounce";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
import { Router } from "@js/common/router";
var paginationSize = 10;
export var MoodboardSelectionCard = function (_a) {
    var onSelected = _a.onSelected;
    var _b = useState([]), moodboards = _b[0], setMoodboards = _b[1];
    var _c = useState(null), newMoodboard = _c[0], setNewMoodboard = _c[1];
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = React.useState(0), lastPage = _e[0], setLastPage = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = useState(""), search = _g[0], setSearch = _g[1];
    var searchRef = useRef(search);
    var pageRef = React.useRef(1);
    var debouncedLoadMoodboards = useCallback(debounce(function () { return loadMoodboards(true); }, 500), []);
    var _h = useState(null), creationError = _h[0], setCreationError = _h[1];
    function loadMoodboards(resetResults) {
        if (resetResults === void 0) { resetResults = false; }
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isLoading) {
                            return [2];
                        }
                        setIsLoading(true);
                        if (resetResults) {
                            pageRef.current = 1;
                        }
                        return [4, fetchApi('moodboards_ajax_list', HttpMethods.get, {
                                search: searchRef.current.toLowerCase(),
                                from: (pageRef.current - 1) * paginationSize,
                            })];
                    case 1:
                        response = _a.sent();
                        return [4, response.json()];
                    case 2:
                        data = _a.sent();
                        setMoodboards(resetResults
                            ? data.moodboards
                            : moodboards.concat(data.moodboards));
                        setTotalCount(data.count);
                        setLastPage(Math.ceil(data.count / paginationSize));
                        setIsLoading(false);
                        return [2];
                }
            });
        });
    }
    useEffect(function () {
        loadMoodboards();
    }, []);
    function updateSearch(newValue) {
        setSearch(newValue);
        searchRef.current = newValue;
        debouncedLoadMoodboards();
    }
    function prepareNewMoodboard() {
        setNewMoodboard({
            name: translate('moodboard_quicksave.default_moodboard_name')
        });
    }
    function select(moodboard) {
        localStorage.setItem('selected_moodboard', JSON.stringify({
            slug: moodboard.slug,
            name: moodboard.name,
        }));
        onSelected();
    }
    function create(moodboard) {
        return __awaiter(this, void 0, void 0, function () {
            var form, url, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = new FormData();
                        form.append('name', moodboard.name);
                        url = Router.generate('moodboards_create', {});
                        return [4, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                },
                                body: form,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status != 200) {
                            setCreationError(translate('moodboard_quicksave.creation_error'));
                            return [2];
                        }
                        return [4, response.json()];
                    case 2:
                        data = _a.sent();
                        select({
                            slug: data.slug,
                            name: moodboard.name,
                        });
                        return [2];
                }
            });
        });
    }
    return (React.createElement("div", { className: "moodboard-selection-card" },
        React.createElement("div", { className: "mb-d" },
            React.createElement("h3", { className: "title" }, translate('moodboard_quicksave.modal.title')),
            React.createElement("div", { className: "search-moodboards input-group" },
                React.createElement("input", { type: "text", className: "form-control search-input", placeholder: translate('moodboard_quicksave.modal.search_placeholder'), "aria-label": translate('moodboard_quicksave.modal.search_placeholder'), "aria-describedby": "search-btn-addon1", value: search, onChange: function (event) { return updateSearch(event.target.value); } }),
                React.createElement("div", { className: "input-group-append" },
                    React.createElement("span", { className: "input-group-text", id: "search-btn-addon1" },
                        React.createElement("i", { className: "iconoir-search" }))))),
        React.createElement("div", { className: "item-list mb-d" },
            moodboards.map(function (moodboard) { return (React.createElement(MoodboardRow, { key: moodboard.slug, moodboard: moodboard, onClick: function () { return select(moodboard); } })); }),
            (isLoading || pageRef.current < lastPage) &&
                React.createElement(InfiniteScroll, { callback: function () {
                        pageRef.current++;
                        loadMoodboards();
                    }, loading: isLoading, seeMoreCount: totalCount - moodboards.length, useIntersection: true })),
        !newMoodboard &&
            React.createElement("div", { className: "create-btn", onClick: prepareNewMoodboard },
                React.createElement("div", null,
                    React.createElement("i", { className: "iconoir-plus-circle icon-middle" }),
                    React.createElement("span", null, translate('moodboard_quicksave.modal.create_btn')))),
        newMoodboard &&
            React.createElement(MoodboardForm, { moodboard: newMoodboard, onCreate: create, error: creationError })));
};
